import type { SVGProps } from 'react'

/**
 * A truck with speed lines — marks a product that has ALREADY shipped
 * (z8nrz7eaex), next to lucide's plain `Truck` for one that can be shipped.
 *
 * Hand-drawn because lucide-react has no "fast truck". Drawn on lucide's 24×24
 * grid with the same stroke, caps and joins, and filling the whole grid so it
 * reads at row-icon size; size it with `className` like any of them.
 */
export function TruckFastIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
      aria-hidden='true'
      {...props}
    >
      {/* Speed lines */}
      <path d='M1 8h4' />
      <path d='M2 11.5h3' />
      <path d='M1 15h2.5' />
      {/* Cargo box */}
      <path d='M6 6.5v-1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1V17' />
      <path d='M6 14v2a1 1 0 0 0 1 1h.3' />
      {/* Between the wheels */}
      <path d='M11.7 17h5.1' />
      {/* Cab */}
      <path d='M16 8.5h3.6a1 1 0 0 1 .8.4l2.4 3.2a1 1 0 0 1 .2.6V16a1 1 0 0 1-1 1h-.8' />
      {/* Wheels */}
      <circle cx='9.5' cy='17.5' r='2.2' />
      <circle cx='19' cy='17.5' r='2.2' />
    </svg>
  )
}
